import PricingInformation from "@/features/billing/ui/pricing/PricingInformation";
import PricingCards from "@/features/billing/ui/pricing/PricingCards";
import PricingScheduling from "@/features/billing/ui/pricing/PricingScheduling";
import PricingAddAgent from "@/features/billing/ui/pricing/PricingAddAgent";
import PricingAskInquiry from "@/features/billing/ui/pricing/PricingAskInquiry";
import PricingFAQ from "@/features/billing/ui/pricing/PricingFAQ";
import PricingRequest from "@/features/billing/ui/pricing/PricingRequest";
import { useAuth } from "@/shared/providers/AuthProvider";
import PricingAddAgentUser from "@/features/billing/ui/pricing/PricingAddAgentUser";
import PricingWilconAI from "@/features/billing/ui/pricing/PricingWilconAI";
import { useWindowWidth } from "@/shared/lib/hooks/useWindowSize";
import PricingAddAgentMobile from "@/features/billing/ui/pricing/PricingAddAgentMobile";

const PricingKorean = () => {
  const { user } = useAuth();
  const width = useWindowWidth();
  return (
    <div
      className={
        "flex min-h-screen w-full flex-col items-center bg-white px-[2px] pb-[50px] pt-[72px] sm:px-[20px] lg:px-0 lg:pb-[112px] lg:pt-[176px]"
      }
    >
      <div className={"w-full max-w-[1024px] px-[20px] sm:px-0"}>
        <PricingInformation />
        <PricingCards />
        <PricingScheduling />
        {user ? (
          <PricingAddAgentUser />
        ) : width! >= 1040 ? (
          <PricingAddAgent />
        ) : (
          <PricingAddAgentMobile />
        )}
        <PricingAskInquiry />
        <PricingFAQ />
        <PricingRequest />
        <PricingWilconAI />
      </div>
    </div>
  );
};

export default PricingKorean;
